import { makeCatalogEvent, prependCatalogName } from '@dashboard/junk-drawer/utils/eventstream';
const CATALOG_NAME = 'wfe_location_selector';
export function locationsSelected(metadata = {}) {
  return makeCatalogEvent(CATALOG_NAME, prependCatalogName({
    unit_count: metadata.unitCount,
    inactive_unit_count: metadata.inactiveUnitCount,
    selected_unit_count: metadata.selectedUnitCount,
    selected_inactive_unit_count: metadata.selectedInactiveUnitCount,
    is_multiple_selection: metadata.isMultipleSelection,
    is_default_selection: metadata.isDefaultSelection,
    is_new_selector: metadata.isNewSelector
  }, CATALOG_NAME));
}
const DATE_FILTER_CHANGED_CATALOG_NAME = 'date_filter_changed';
export function dateFilterChanged(metadata = {}) {
  return makeCatalogEvent(DATE_FILTER_CHANGED_CATALOG_NAME, prependCatalogName({
    begin_date: metadata.beginDate,
    end_date: metadata.endDate,
    range_option_selected: metadata.rangeOptionSelected
  }, DATE_FILTER_CHANGED_CATALOG_NAME));
}